export default function ResetPasswordView() {
    return (
        <div>
            ResetPassword
        </div>
    );
}